<template>
    <div class="gp-app-screenshot">
        <div
            ref="scrollSnapShoot"
            class="gp-app-screenshot__wrapper"
            :class="{
                'is-vertical': type === 'v',
                'is-horizontal': type === 'h',
            }"
        >
            <div
                v-for="(img, index) of newImages"
                :key="index"
                class="gp-app-screenshot__img"
                :class="{
                    'is-vertical': type === 'v',
                    'is-horizontal': type === 'h',
                }"
            >
                <gp-image
                    :src="img"
                    :lazy="true"
                    preview="0"
                    @load="refreshPreview"
                    @click="pictureClick"
                />
            </div>
        </div>
    </div>
</template>

<script>
import GpImage from '@/components/gp-image';
import {getQueryString, getUrlParams} from '@/utils/url';
import {convert2GIPSUrl} from '@/utils/utility';
export default {
    components: {
        GpImage,
    },
    props: {
        imgs: {
            type: Array,
            required: true,
        },
        type: {
            type: String,
            validator: function (value) {
                return ['h', 'v'].indexOf(value) !== -1;
            },
            required: true,
        },
        appVideoInfo: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            images: [],
            newImages: [],
        };
    },
    computed: {
        getZipedImgUrl() {
            return convert2GIPSUrl(this.appVideoInfo.poster, 333, 187, 80);
        },
    },
    mounted() {
        this.images = this.imgs;
        this.$preview.on('afterInit', () => {
            this.$emit('open');
            this.$preview.self.listen('close', () => {
                this.$root.$data.videoView = true;
                this.$emit('close');
            });
        });
        this.processImg();
    },
    methods: {
        refreshPreview() {
            this.$previewRefresh();
        },
        pictureClick() {
            this.$root.$data.videoView = false;
            const {channelid} = getUrlParams();
            const {app_name, package_name, app_type, app_id} = this.appVideoInfo;
            this.$logger.click({
                source: channelid,
                ext: {
                    id: package_name,
                    ext: {
                        sid: getQueryString('sid'),
                        srcId: getQueryString('srcid'),
                        channelid: getQueryString('channelid') || '',
                        gameId: app_id,
                        gameType: app_type,
                        gameName: app_name,
                    },
                    pos: '',
                },
                value: 'picture',
                network: this.$wifi ? 'wifi' : '4g',
            });
        },
        // 先遍历图片进行压缩赋予新的数组，再去渲染图片
        processImg() {
            if (this.type === 'v') {
                this.images.forEach(item => {
                    // 原 宽 174 高 309
                    this.newImages.push(convert2GIPSUrl(item, 174, 309, 90));
                });
            }
            else if (this.type === 'h') {
                this.images.forEach(item => {
                    // 原 宽 413 高 309
                    this.newImages.push(convert2GIPSUrl(item, 413, 309, 90));
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/mixins";
    $design-width: 1242;

    @include b(app-screenshot) {

        @include e(wrapper) {
            overflow-x: scroll;
            overflow-y: hidden;
            white-space: nowrap;
            padding-top: px2rem(59);
            padding-bottom: px2rem(45.2);

            &::-webkit-scrollbar {
                display: none;
            }

            @include when(vertical) {
                height: px2rem(618);
            }

            @include when(horizontal) {
                height: px2rem(618);
            }
        }
        @include e(img) {
            display: inline-block;
            margin-right: px2rem(30);
            vertical-align: top;
            position: relative;

            @include when(vertical) {
                width: px2rem(348);
                height: px2rem(618);
            }

            @include when(horizontal) {
                width: px2rem(825);
                height: px2rem(618);
            }

            @include when(first) {
                width: px2rem(1100);
            }

            &:first-child {
                margin-left: px2rem(51);
            }

            &:last-child {
                margin-right: px2rem(51);
            }

            .gp-image {
                width: 100%;
                height: 100%;
                border-radius: px2rem(39);
            }
            .gp-app-video__control {
                border-radius: px2rem(39);
            }
        }
        @include e(imgcover) {
            display: none;
            position: absolute;
            left: px2rem(1100);
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0);
            z-index: 100
        }
    }
</style>